/* global LPBaseConfig, jQuery */

/**
 * LP Fixed Add-to-Cart Bar (standalone)
 *
 * Extracted from lp-custom-handlers-v3. Shows/hides the fixed
 * "Add to Cart" bar based on whether the main product description
 * section is in the viewport, and toggles the `withBar` class on
 * the launcher / back-to-top elements.
 *
 * Drop-in: include this script in <head>. It self-guards so it
 * won't run if the feature is already provided by another script.
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Existence guard — don't fire if the feature already exists on the page
  // ---------------------------------------------------------------------------

  // 1) This exact standalone module already initialized.
  if (window.LPFixedAddToCart && window.LPFixedAddToCart.initialized) {
    return;
  }

  // 2) The full handlers instance is present and already provides toggleFixedBar.
  //    (window.LP is the LPCustomHandlers instance; window.LPCustomHandlers is the class.)
  var instanceHasFeature =
    window.LP && typeof window.LP.toggleFixedBar === 'function';
  var classHasFeature =
    typeof window.LPCustomHandlers === 'function' &&
    window.LPCustomHandlers.prototype &&
    typeof window.LPCustomHandlers.prototype.toggleFixedBar === 'function';

  if (instanceHasFeature || classHasFeature) {
    // The main bundle owns this behavior — defer to it.
    return;
  }

  // ---------------------------------------------------------------------------
  // Config resolution (only the classes this feature needs)
  // ---------------------------------------------------------------------------

  var DEFAULT_OBSERVABLE = {
    mainProductDescription: '.observable--main-product-description',
    fixedAddToCart: '.observable--fixed-add-to-cart',
  };

  function resolveObservableClasses() {
    // Prefer an existing LPConfig (set by the main bundle) if present,
    // then fall back to LPBaseConfig, then to our defaults.
    var fromLPConfig =
      window.LPConfig && window.LPConfig.observableClasses
        ? window.LPConfig.observableClasses
        : null;
    var fromBase =
      typeof LPBaseConfig !== 'undefined' && LPBaseConfig.observableClasses
        ? LPBaseConfig.observableClasses
        : null;

    var src = fromLPConfig || fromBase || {};
    return {
      mainProductDescription:
        src.mainProductDescription || DEFAULT_OBSERVABLE.mainProductDescription,
      fixedAddToCart: src.fixedAddToCart || DEFAULT_OBSERVABLE.fixedAddToCart,
    };
  }

  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  var qsa = function (sel, root) {
    return [].slice.call((root || document).querySelectorAll(sel));
  };

  /**
   * Check whether an element is currently visible within the viewport.
   */
  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0
    );
  }

  // ---------------------------------------------------------------------------
  // Core behavior
  // ---------------------------------------------------------------------------

  var observableClasses = resolveObservableClasses();

  /**
   * Show or hide the fixed "Add to Cart" bar depending on whether
   * the main product description section is currently in the viewport.
   */
  function toggleFixedBar() {
    var sections = qsa(observableClasses.mainProductDescription);
    var anyVisible = sections.some(function (el) {
      return isInViewport(el);
    });

    qsa(observableClasses.fixedAddToCart).forEach(function (el) {
      // remove `is-hidden` when the description is out of view → bar shows
      el.classList.toggle('is-hidden', anyVisible);
    });

    // Adjust launcher and back-top positioning
    qsa('iframe#launcher, #back-top').forEach(function (el) {
      el.classList.toggle('withBar', !anyVisible);
    });
  }

  // ---------------------------------------------------------------------------
  // Wiring (scroll/resize with rAF throttle) + init
  // ---------------------------------------------------------------------------

  var ticking = false;
  function onScrollResize() {
    if (!ticking) {
      requestAnimationFrame(function () {
        toggleFixedBar();
        ticking = false;
      });
      ticking = true;
    }
  }

  function init() {
    // Run once on init so initial state is correct.
    toggleFixedBar();
    document.addEventListener('scroll', onScrollResize);
    window.addEventListener('resize', onScrollResize);
    window.LPFixedAddToCart.initialized = true;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // Expose a small public surface so other scripts can detect/reuse it.
  window.LPFixedAddToCart = {
    initialized: false,
    toggle: toggleFixedBar,
    refreshConfig: function () {
      observableClasses = resolveObservableClasses();
    },
  };

  onReady(init);
})();